module.exports = __webpack_public_path__ + "img/Dashboard.247f7886.svg";